import {useSelector} from 'react-redux';

//Selectors
import {indiannessSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

//Components
import PriceNBookingButtonNPersuasion from '../PriceNBookingButtonNPersuasion/PriceNBookingButtonNPersuasion';
import CaptivateGallery from '../CaptivateGallery/CaptivateGallery';
import HotelDetails from '../HotelDetails/HotelDetailsMain';
import WhyIndianBook from '../../../../../stories/components/hotels/DetailsPageUnif/WhyIndianBook/WhyIndianBook';

//Styles
import * as S from './HotelOverview.styles';

interface HotelInfoProps {
  isSeoDetailPage: boolean;
  pageName: string;
  isSeoUnif: boolean;
  isSoldOut?: boolean;
  setCalendarMode: (args) => {};
  handlOpenCalendar: () => {};
}

const HotelInfo: React.FC<HotelInfoProps> = ({
  isSeoDetailPage,
  pageName,
  isSeoUnif,
  isSoldOut,
  setCalendarMode,
  handlOpenCalendar,
}) => {
  const indianness = useSelector(indiannessSelector);

  return (
    <S.OuterWrapperDiv>
      <S.HotelOverviewContainer>
        <S.HotelInfoImageContainer>
          <HotelDetails
            isSeoDetailPage={isSeoDetailPage}
            pageName={pageName}
            isSeoUnif={isSeoUnif}
            indianness={indianness}
          />

          {(isSeoDetailPage || !isSeoUnif) && (
            <CaptivateGallery isSeo={!isSeoDetailPage && isSeoUnif} isSoldOut={isSoldOut} />
          )}
        </S.HotelInfoImageContainer>
        {(isSeoDetailPage || !isSeoUnif) && (
          <PriceNBookingButtonNPersuasion handlOpenCalendar={handlOpenCalendar} />
        )}
      </S.HotelOverviewContainer>
      {!!indianness?.cardInfo?.titleText && <WhyIndianBook indianness={indianness} />}
    </S.OuterWrapperDiv>
  );
};

export default HotelInfo;
